'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectionIcon = function SelectionIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M16,4 C9.383,4 4,9.384 4,16 C4,22.616 9.383,28 16,28 C22.616,28 28,22.616 28,16 C28,9.384 22.617,4 16,4 L16,4 Z M21.341,12.866 L13.841,19.866 C13.745,19.955 13.622,20 13.5,20 C13.372,20 13.244,19.951 13.146,19.854 L10.646,17.354 C10.451,17.159 10.451,16.842 10.646,16.647 C10.841,16.451 11.158,16.451 11.353,16.647 L13.511,18.805 L20.658,12.135 C20.859,11.947 21.176,11.957 21.365,12.158 C21.554,12.36 21.543,12.677 21.341,12.866 L21.341,12.866 Z' })
  );
};

SelectionIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = SelectionIcon;